import { SignIn } from '@clerk/nextjs';
import { Theme } from '@clerk/types';
import { ErrorBoundary } from '@firmable/common';
import { UserOnboarding } from '@web/components/UserOnboarding';
import { StoreChromeExtensionQueryParams } from '@web/components/SignInActions/StoreChromeExtensionQueryParams';
import { NotifyChromeExtensionOnSignOut } from '@web/components/SignOutActions/NotifyChromeExtensionOnSignOut';
import { Routes } from '@web/constants/routes';
import Head from 'next/head';

const signInAppearance: Theme = {
  elements: {
    logoBox: 'justify-center h-[30px]',
    headerTitle: 'text-center text-[30px] leading-[40px] font-semibold text-neutral-800',
    headerSubtitle: 'text-center text-sm text-neutral-500',
    socialButtonsBlockButton: 'text-content-dark bg-surface-white !border border-stroke-light px-4 py-2 !shadow-none',
    formButtonPrimary: 'bg-brand-1-600 hover:bg-brand-1-700 !shadow-none text-label-large px-4 py-2',
    buttonArrowIcon: 'hidden',
    formFieldAction__identifier: 'text-label-small text-brand-1-600 hover:text-brand-1-700',
    formFieldLabel: 'text-label-large text-content-dark',
    footerActionText: 'text-body-large text-content-dark',
    footerActionLink: 'text-label-large text-brand-1-600 hover:text-brand-1-700',
    selectButton__countryCode: 'bg-neutral-100/40',
  },
};

const SignInPage = () => {
  return (
    <div className="flex min-w-full min-h-screen">
      <Head>
        <title>Firmable Login</title>
      </Head>
      {/* for screen size greater than 1279 */}
      <ErrorBoundary>
        <div className="hidden xl:flex w-screen min-h-[100dvh] bg-[url('/images/orange-rectangle.svg')] bg-no-repeat bg-cover">
          <div className="flex justify-between min-w-[1280px] max-w-[1440px] min-h-[100dvh] w-full m-auto px-[80px]">
            <UserOnboarding.UserOnboardingLayout>
              <UserOnboarding.WelcomeMessage variant="signin" />
            </UserOnboarding.UserOnboardingLayout>
            <div className="relative flex items-center h-full px-12 py-14">
              <SignIn path={Routes.signInPath} signUpUrl={Routes.signUpPath} appearance={signInAppearance} />
            </div>
          </div>
        </div>
        {/* for mobile */}
        <div className="xl:hidden flex min-h-[100dvh] w-full mx-auto justify-center bg-[url('/images/orange-rectangle.svg')] bg-no-repeat bg-cover px-0 py-6 sm:px-3">
          <SignIn path={Routes.signInPath} signUpUrl={Routes.signUpPath} appearance={signInAppearance} />
        </div>
        <StoreChromeExtensionQueryParams />
        <NotifyChromeExtensionOnSignOut />
      </ErrorBoundary>
    </div>
  );
};

export default SignInPage;
